// src/contexts/GuideForceContext.js
//
// Broadcasts the active TagGuide step number to any component that needs to
// simulate a hover/forced-visible state for guide purposes.
//
// Usage in a consuming component:
//   const { tagGuideStep } = useGuideForce();
//
// null  → no guide active, behave normally
// 1–5   → that step is showing; check against your component's relevant step

import { createContext, useContext } from 'react';

const GuideForceContext = createContext({ tagGuideStep: null });

export const useGuideForce = () => useContext(GuideForceContext);

export const GuideForceProvider = ({ children, tagGuideStep }) => (
  <GuideForceContext.Provider value={{ tagGuideStep }}>
    {children}
  </GuideForceContext.Provider>
);

export default GuideForceContext;